<script>
    // based on suggestions from:
    // Inclusive Components by Heydon Pickering https://inclusive-components.design/collapsible-sections/
    export let headerText;

    let expanded = false

    function handleClick(event) {
        expanded = !expanded; 
        if (document.getElementById('advancedSettingsButton').innerHTML == 'Show Advanced Settings') {
            document.getElementById('advancedSettingsButton').innerHTML = 'Hide Advanced Settings';
        } else {
            document.getElementById('advancedSettingsButton').innerHTML = 'Show Advanced Settings';
        }
        event.preventDefault();
        event.stopPropagation();   
    }
</script>

<div class="collapsible">
    <h3>
        {headerText}<button id="advancedSettingsButton" style="width: 300px; padding: 2px; text-align: center;" aria-expanded={expanded} on:click={(event) => handleClick(event)}>Show Advanced Settings</button>
    </h3>
    
    <div class='contents' hidden={!expanded}>
        <slot></slot>
    </div>
</div>

<style>
  .collapsible {
    border-bottom: 1px solid var(--gray-light, #eee);
  }
	
	h3 {
		margin: 0;
	}
	
  button {
    background-color: var(--background, #fff);
    color: var(--gray-darkest, #282828);
    display: flex;
		justify-content: space-between;
    width: 20% !important;
		border: none;
		margin: 0;
		padding: 1em 0.5em;
  }

  button[aria-expanded="true"] {
    border-bottom: 1px solid var(--gray-light, #eee);
  }

</style>